import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import {
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import useAsync from 'react-use/lib/useAsync';
import { Progress } from '@backstage/core-components';
import {
  Stats,
  useGithubStatisticsForProjects,
} from '../../hooks/useGithubStatistics';

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom' as const,
      display: true,
    },
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
      title: {
        display: true,
        text: 'Number of developers',
      },
      beginAtZero: true,
    },
  },
};

export const ProjectStatsCard = () => {
  const fetchGithubStatisticsApi = useGithubStatisticsForProjects();

  const { value, loading } = useAsync(async () => {
    return fetchGithubStatisticsApi();
  }, []);

  if (loading) {
    return <Progress />;
  }
  if (!value || Object.keys(value).length === 0) {
    return <></>;
  }

  const data = {
    labels: Object.keys(value).map(key => key.substring(key.indexOf('/') + 1)),
    datasets: [
      {
        label: 'Internal',
        data:
          Object.values(value).map((entry: Stats) => entry.internal.devs) ?? [],
        backgroundColor: '#008A8D',
      },
      {
        label: 'External',
        data:
          Object.values(value).map((entry: Stats) => entry.external.devs) ?? [],
        backgroundColor: '#ff4081',
      },
    ],
  };

  return (
    <Card>
      <CardHeader title="Statistics" />
      <Divider />
      <CardContent
        style={{
          height: '550px',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Bar data={data} options={options} />
      </CardContent>
    </Card>
  );
};
